// ** React Imports
import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";

// ** Redux Imports
import { Provider } from "react-redux";
import { store } from "./redux/store";

import "./index.css";
import reportWebVitals from "./reportWebVitals";
import Spinner from "./@core/components/spinner/FalbackSpinner";
import { AbilityContext } from "./casl/Can";
import ability from "./casl/Ability";
import { ThemeContext } from "./utility/context/ThemeColors";
import { AuthProvider } from "./utility/hooks/useAuth";
import App from "./App";
import { ThemeProvider } from "./utility/context/theme-context";



// ** Lazy load app
const LazyApp = lazy(() => import("./App"));
// const LazyApp = lazy(() => {
//   return new Promise<{ default: React.ComponentType<any> }>((resolve) => {
//     setTimeout(() => resolve({ default: () => <App /> }), 30000);
//   });
// });
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  // <React.StrictMode>
    <Provider store={store}>
      <Suspense fallback={<Spinner />}>
        {/* <AuthProvider> */}
          <AbilityContext.Provider value={ability}>
              <ThemeProvider>
              <LazyApp />
              </ThemeProvider>
          </AbilityContext.Provider>
        {/* </AuthProvider> */}
      </Suspense>
    </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
